<template>
  <div class="submit-alert" v-show="visible">
    <div class="bg-content"></div>
    <div class="main-content">
      <div class="alert-title"></div>
      <div class="alert-content">
        <div class="content-left"></div>
        <div class="content-right">
          <template v-if="multiStatus">
            <div class="content-text">
              多选题至少选择两个答案！
            </div>
            <button class="btn-back fr" @click="closeDialog"/>
          </template>
          <!-- 未作答状态 -->
          <template v-else-if="!isAnswered">
            <div class="content-text">
              【{{course}}】尚未作答。<br/>
              请作答后交卷！
            </div>
            <button class="btn-back fr" @click="closeDialog"/>
          </template>
          <!-- 已作答，第一次提示 -->
          <template v-else-if="firstStatus">
            <div class="content-text">
              【{{course}}】尚有{{unAnswerCount}}道题未作答。<br/>
              交卷后将不能返回本科目作答，还要继续交卷吗？
            </div>
            <button class="btn-submit fr" @click.once="firstStatus=false"/>
            <button class="btn-back fr" @click="closeDialog"/>
          </template>
          <!-- 第二次确认提示 -->
          <template v-else>
            <div class="content-text">
              再次确认是否交卷？<br/>
              交卷后将不能继续答题！
            </div>
            <button class="btn-back fr" @click="closeDialog"/>
            <button class="btn-submit fr" @click.once="confirmFn"/>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'submitAlert',
  props: {
    visible: { type: Boolean, default: false },
    multiStatus: { type: Boolean, default: false },
    course: { type: String, default: '课程' },
  },
  data() {
    return {
      firstStatus: true,  //  是否处于第一步状态
      isAnswered: false,  //  是否已答题
      unAnswerCount: 0,  //  未答题数量
    }
  },
  computed: {
    ...mapGetters([
      'questions',
      'currentQuestion',
      'currentQuestionType',
      'currentQuestionIndex'
    ])
  },
  watch: {
    visible(newVal) {
      if(newVal) {
        let allCount = 0
        let unAnswerCount = 0
        for(let item of this.questions) {
          item.list.forEach((ques) => {
            allCount++
            !ques.isAnswer && unAnswerCount++
          })
        }
        this.isAnswered = (allCount !== unAnswerCount)
        this.unAnswerCount = unAnswerCount
      }
    }
  },
  methods: {
    closeDialog() {
      this.hide();
    },
    hide() {
      this.$emit('update:visible', false)
      this.$emit('update:multiStatus', false)
      this.firstStatus = true
    },
    confirmFn() {
      this.hide();
      this.$emit('submit')
      // this.firstStatus = true
    }
  }
}
</script>

<style lang="scss">
$bgUrl: '~@/assets/images/doExam/';
.submit-alert {
  .bg-content{
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: rgba(0,0,0,.6);
    z-index: 999;
  }
  .main-content {
    position: fixed;
    box-sizing: border-box;
    left: 50%;
    top: 50%;
    margin-left: -263px;
    margin-top: -145px;
    padding: 22px 30px 0;
    width: 526px;
    height: 291px;
    background: url($bgUrl + 'ts_d.gif') no-repeat;
    z-index: 999;
    .alert-title {
      width: 120px;
      height: 40px;
      background: url($bgUrl + 'ts_1.gif') no-repeat;
    }
    .alert-content {
      overflow: hidden;
      padding-top: 30px;
      padding-left: 5px;
      .content-left {
        float: left;
        width: 130px;
        height: 135px;
        background: url($bgUrl + 'ts_2.gif') no-repeat;
      }
      .content-right {
        float: right;
        width: 280px;
        .content-text {
          height: 120px;
          font-size: 16px;
          color: red;
          overflow-y: auto;
          font-weight: bold;
          line-height: 24px;
        }
        button {
          width: 84px;
          height: 31px;
          margin-right: 10px;
          cursor: pointer;
          border: none;
          &.btn-back {
            background: url($bgUrl + 'ts_4.gif') no-repeat;
          }
          &.btn-submit {
            background: url($bgUrl + 'submit1.gif') no-repeat;
          }
        }
      }
    }
  }
}
</style>

